<div class="page-wrapper section-hr-direct">

    <app-multi-lingual></app-multi-lingual>
    <div class="new-login-container">
        <div class="heading">{{'Login.WelComeText' | translate}}</div>
        <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" class="active">
                <a [routerLink]="['/login']" routerLinkActive="router-link-active"    role="tab"
                    data-toggle="tab">{{'Login.Title'|translate}}</a>
            </li>
            <li role="presentation">
                <a [routerLink]="['/register']" role="tab" data-toggle="tab">{{'Register.Title'|translate}}</a>
            </li>
        </ul>
        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active login" id="login">
                <form [formGroup]="loginForm" novalidate (ngSubmit)="login(loginForm.value, loginForm.valid)">
                    <div class="error-message" style="opacity: 1;">{{errorMessage|translate}}
                    </div>
                    <label>{{'Login.UserName' | translate}}</label>
                    <input type="text" formControlName="UserName">

                    <label>{{'Login.Password' | translate}} <a tabindex="-1"
                            [routerLink]="['/forgotpassword']">{{'ForgotPassword.Text'|translate}}?</a></label>
                    <input type="password" formControlName="Password">

                    <div class="checkbox" *ngIf="false">
                        <input type="checkbox" id="rememberme" formControlName="RememberMe" name="rememberme">
                        <label for="rememberme">{{'Login.RememberMe' | translate}}</label>
                    </div>

                    <input type="submit" id="login" [disabled]="!loginForm.valid" class="btn btn-main"
                        value="{{'Common.Login' | translate}}" />
                </form>
            </div>



        </div>
    </div>
</div>
<app-outer-footer></app-outer-footer>